export default __webpack_public_path__ + "static/media/sponsor_mobile.daa81dc3.png";